import React from "react";
import { createNew } from "MODULES/shared/decorators";
import { CreatePart } from "MODULES/parts/components";

export default createNew((open, close) => (
  <CreatePart open={open} close={close} />
));



// WEBPACK FOOTER //
// ./app/modules/parts/components/Search/NewPart.jsx